//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  Fragment,
} from "react";
import context from "context/context";
import { useHistory, useLocation } from "react-router-dom";
import * as moment from "moment";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

// custom pages
import promotion from "apis/promotion/promotion";
import { styles } from "./styles";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

//Helpers
import { dateFormat } from "helpers/dataFormat";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

const valueArr = [
  { label: "None", value: "NONE" },
  { label: "Include", value: "INCLUDE" },
  { label: "Exclude", value: "EXCLUDE" },
];
const valueArrprod = [
  { label: "None", value: "NONE" },
  { label: "Include", value: "INCLUDE" },
  { label: "Exclude", value: "EXCLUDE" },
  { label: "Eligible", value: "Eligible" },

];
const valueArrPromo = [
  { label: "None", value: "NONE" },
  { label: "Include", value: "INCLUDE" }

];

export default function Promotion(props) {
  const { state, dispatch } = useContext(context);
  const { getCriteriaRule, updateCriteriaRule } = promotion();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();
  const [promotionData, setPromotionData] = useState({});
  const { t, i18n } = useTranslation();

  const [states, setstates] = useState({
    resData: {
      product_primary_class_id: "NONE",
      business_unit_code: "NONE",
      label_class_code: "NONE",
      product_brand_name_code: "NONE",
      loyalty_category_code: "NONE",
      product_code: "NONE",
      order_source_code: "NONE",
      primary_major_class_code: "NONE",
      primary_submajor_class_code: "NONE",
      primary_minor_class_code: "NONE",
      loyalty_id: "NONE"
    },
    originalData: {
      product_primary_class_id: "NONE",
      business_unit_code: "NONE",
      label_class_code: "NONE",
      product_brand_name_code: "NONE",
      loyalty_category_code: "NONE",
      product_code: "NONE",
      order_source_code: "NONE",
      primary_major_class_code: "NONE",
      primary_submajor_class_code: "NONE",
      primary_minor_class_code: "NONE",
      loyalty_id: "NONE"
    },
    edittedData: {},
    isEdit: false,
  });

  const { resData, originalData, edittedData, isEdit } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Promotion Management", "Criteria Rule"],
    });
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      setPromotionData(location?.state?.data);
    }
  });

  // handling api calls
  useEffect(() => {
    if (location?.state?.id) {
      handleGet();
    }
  }, []);

  // get api func
  const handleGet = async () => {
    try {
      let values;
      values = {
        promotionId: location?.state?.id,
      };
      let res = await getCriteriaRule(values);
      if (res) {
        setStates({
          resData: { ...resData, ...res?.data },
          originalData: { ...originalData, ...res?.data },
        });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // update api func
  const handleUpdate = async () => {
    try {
      let values;
      values = {
        promotionId: location?.state?.id,
        edittedData,
      };
      const res = await updateCriteriaRule(values);
      if (res && res?.status === "SUCCESS") {
        handleGet()
        setStates({
          edittedData: {},
          isEdit: false,
        });
        toast.success("Updated successfully.", {
          toastId: "criteria-rule-update-success",
        });
        return
      }
      toast.error("Unable to update this time.", {
        toastId: "criteria-rule-update-failed",
      });
    } catch (e) {
      console.log({ e });
    }
  };

  function capitalizeFirstLetter(string) {
    if (string) {
      return string?.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
    return "None"
  }

  return (
    <React.Fragment>
      <Grid container className={classes.root}>
        <Grid xs={12} sm={6} lg={6}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18 }}>
            <strong>{t("Criteria Rule")}</strong>
          </span>
        </Grid>
        <Grid
          xs={12}
          sm={6}
          lg={6}
          style={{ textAlign: "end", paddingTop: "10px" }}
        ></Grid>
      </Grid>

      <Grid container className={classes.promotionDetails}>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t("Promotion Id")}</strong> : {promotionData?.promotion_id}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t("Promotion Name")}</strong> :{" "}
          {promotionData?.promotion_name}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t("Promotion Description")}</strong> :{" "}
          {promotionData?.promotion_description}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t("Start Date")}</strong> :{" "}
          {promotionData?.start_date
            ? dateFormat(promotionData?.start_date, i18n.language)
            : "-"}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t("End Date")}</strong> :{" "}
          {promotionData?.end_date
            ? dateFormat(promotionData?.end_date, i18n.language)
            : "-"}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t("Expired")}</strong> :{" "}
          {promotionData?.expired ? (
            <span style={{ color: "red" }}>{t("Yes")}</span>
          ) : (
            <span style={{ color: "green" }}>{t("No")}</span>
          )}
        </Grid>
        {/* <Grid xs={12} sm={4} lg={4}>
          <strong>{t("Ranking")}</strong> : {promotionData?.ranking}
        </Grid> */}
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t("Type")}</strong> : {promotionData?.type}
        </Grid>
        <Grid xs={12} sm={4} lg={4}>
          <strong>{t("Frequency")}</strong> : {t(promotionData?.frequency)}
        </Grid>
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          {promotionData?.is_active &&
            (
              <Button
                className={`${classes.createBtn} dash-1-filter-btn`}
                onClick={() => {
                  setStates({ isEdit: true });
                }}
              >
                {t("Edit")}
              </Button>
            )}
        </Grid>
      </Grid>
      <Grid container spacing={4} style={{ padding: 10, fontSize: 16 }}>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t("MPC")}</strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Active"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.product_primary_class_id}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        product_primary_class_id: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        product_primary_class_id: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(
                    originalData?.product_primary_class_id
                  )}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
         <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t("GL Cost Center")} </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"GL Cost Center"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.business_unit_code}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        business_unit_code: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        business_unit_code: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.business_unit_code)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid> 
       <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Label Class Code")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Label Class Code"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.label_class_code}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        label_class_code: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        label_class_code: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.label_class_code)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid> 
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t("Brand")} </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Brand"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.product_brand_name_code}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        product_brand_name_code: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        product_brand_name_code: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.product_brand_name_code)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
         <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t("Sales Category")} </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Sales Category"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.loyalty_category_code}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        loyalty_category_code: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        loyalty_category_code: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.loyalty_category_code)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid> 
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t("Product Code")} </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Product Code"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.product_code}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        product_code: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        product_code: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArrprod.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.product_code)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
         <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Order Source Code")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Order Source Code"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.order_source_code}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        order_source_code: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        order_source_code: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.order_source_code)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Primary Major Class Code")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Primary Major Class Code"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.primary_major_class_code}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        primary_major_class_code: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        primary_major_class_code: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.primary_major_class_code)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Primary Submajor Class Code")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Primary Submajor Class Code"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.primary_submajor_class_code}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        primary_submajor_class_code: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        primary_submajor_class_code: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.primary_submajor_class_code)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Primary Minor Class Code")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Primary Minor Class Code"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.primary_minor_class_code}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        primary_minor_class_code: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        primary_minor_class_code: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.primary_minor_class_code)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Loyalty Id")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Loyalty Id"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.loyalty_id}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        loyalty_id: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        loyalty_id: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.loyalty_id)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid> 
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Order Promotion Code")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Order Promotion code"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.order_promotion_code}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        order_promotion_code: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        order_promotion_code: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArrprod.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.order_promotion_code)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Promotion")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Promotion"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.promotion}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        promotion: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        promotion: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArrPromo.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.promotion)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Order Level Coupon")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Order Level Coupon"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.order_level_coupon}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        order_level_coupon: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        order_level_coupon: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArrprod.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.order_level_coupon)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Line Promo Coupon")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Line Promo Coupon"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.line_promo_coupon}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        line_promo_coupon: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        line_promo_coupon: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArrprod.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.line_promo_coupon)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Equipment Order Number")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Equipment Order Number"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.equipment_order_number}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        equipment_order_number: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        equipment_order_number: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArrprod.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.equipment_order_number)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
         <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t("Shipto")}{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Shipto"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={originalData?.customer_account_number}
                  onChange={(e) => {
                    setStates({
                      originalData: {
                        ...originalData,
                        customer_account_number: e.target.value,
                      },
                      edittedData: {
                        ...edittedData,
                        customer_account_number: e.target.value,
                      },
                    });
                  }}
                >
                  {valueArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {capitalizeFirstLetter(originalData?.customer_account_number)}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          {isEdit && (
            <Fragment>
              <Button
                className={classes.cancelBtn}
                onClick={() => {
                  setStates({
                    originalData: resData,
                    edittedData: {},
                    isEdit: false,
                  });
                }}
              >
                {t("Cancel")}
              </Button>
              &nbsp; &nbsp; &nbsp;
              <Button
                className={classes.submitBtn}
                onClick={() => {
                  handleUpdate();
                }}
              >
                {t("Update")}
              </Button>
            </Fragment>
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
